import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .bc-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .bc-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .bc-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .bc-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(13,148,136,0.08), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .bc-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 700px; height: 700px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.07), rgba(13,148,136,0.04)); filter: blur(90px); pointer-events: none; }
  .bc-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .bc-hero-inner { grid-template-columns: 1fr; } .bc-hero-card { display: none; } }

  .bc-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0fdfa; border: 1px solid #99f6e4; font-size: 13px; font-weight: 500; color: #0f766e; margin-bottom: 28px; }
  .bc-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #0d9488; display: inline-block; animation: bc-pulse 2s ease-in-out infinite; }
  @keyframes bc-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(13,148,136,0.5); } 50% { box-shadow: 0 0 0 6px rgba(13,148,136,0); } }

  .bc-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .bc-gradient-text { background: linear-gradient(135deg, #0d9488 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .bc-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .bc-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .bc-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .bc-btn-primary:hover { background: #0d9488; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(13,148,136,0.3); }
  .bc-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .bc-btn-secondary:hover { border-color: #0d9488; color: #0f766e; background: #f0fdfa; }
  .bc-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .bc-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .bc-trust-check { width: 20px; height: 20px; background: #ccfbf1; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #0d9488; flex-shrink: 0; }

  /* Hero Card */
  .bc-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .bc-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .bc-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .bc-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .bc-card-badge { background: #f0fdfa; color: #0f766e; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .bc-contract-item { display: flex; align-items: flex-start; padding: 13px 14px; border-radius: 12px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; gap: 12px; }
  .bc-contract-icon { font-size: 16px; flex-shrink: 0; margin-top: 1px; }
  .bc-contract-name { font-size: 13px; font-weight: 600; color: #334155; }
  .bc-contract-detail { font-size: 11px; color: #94a3b8; margin-top: 2px; }
  .bc-contract-right { margin-left: auto; display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
  .bc-contract-badge { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .bc-status-done { background: #ccfbf1; color: #0f766e; }
  .bc-status-review { background: #fef9c3; color: #854d0e; }
  .bc-status-draft { background: #dbeafe; color: #1e40af; }
  .bc-card-metric { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #134e4a, #0d9488); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .bc-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .bc-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .bc-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats ── */
  .bc-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .bc-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .bc-stats-grid { grid-template-columns: 1fr 1fr; } }
  .bc-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .bc-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .bc-stat-item:nth-child(2n) { border-right: none; } .bc-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .bc-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #0d9488; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .bc-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .bc-section { padding: 96px 24px; }
  .bc-container { max-width: 1200px; margin: 0 auto; }
  .bc-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .bc-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .bc-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .bc-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #0d9488; margin-bottom: 12px; }

  /* ── Contract Types ── */
  .bc-types-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .bc-types-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .bc-types-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .bc-types-grid { grid-template-columns: 1fr; } }
  .bc-type-card { background: #fff; padding: 32px 28px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .bc-type-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .bc-type-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; background: linear-gradient(90deg, #0d9488, #0891b2); }
  .bc-type-card:hover::before { opacity: 1; }
  .bc-type-icon { font-size: 28px; margin-bottom: 16px; }
  .bc-type-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .bc-type-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; margin-bottom: 16px; }
  .bc-type-covers { font-size: 11.5px; font-weight: 600; color: #0d9488; }

  /* ── Why Matters ── */
  .bc-why-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .bc-why-grid { grid-template-columns: 1fr; gap: 48px; } }
  .bc-why-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .bc-why-left p { font-size: 1rem; color: #64748b; line-height: 1.78; margin-bottom: 32px; }
  .bc-risk-items { display: flex; flex-direction: column; gap: 14px; }
  .bc-risk-item { display: flex; gap: 16px; padding: 16px 18px; background: #fff; border-radius: 14px; border: 1px solid #fecdd3; }
  .bc-risk-icon { width: 38px; height: 38px; border-radius: 10px; background: #fee2e2; display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0; }
  .bc-risk-title { font-size: 0.92rem; font-weight: 700; color: #991b1b; margin-bottom: 3px; }
  .bc-risk-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }
  .bc-included-list { display: flex; flex-direction: column; gap: 16px; }
  .bc-included-item { display: flex; gap: 14px; padding: 16px 18px; background: #f0fdfa; border-radius: 14px; border: 1px solid #99f6e4; }
  .bc-included-icon { width: 36px; height: 36px; border-radius: 10px; background: #ccfbf1; display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
  .bc-included-title { font-size: 0.92rem; font-weight: 700; color: #0d1b3e; margin-bottom: 3px; }
  .bc-included-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }

  /* ── Process ── */
  .bc-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .bc-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .bc-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .bc-process-grid { grid-template-columns: 1fr; } }
  .bc-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #0d9488, #0891b2); z-index: 0; }
  @media (max-width: 900px) { .bc-process-grid::before { display: none; } }
  .bc-process-step { text-align: center; position: relative; z-index: 1; }
  .bc-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .bc-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .bc-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── Back Link ── */
  .bc-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #0d9488; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .bc-back-btn:hover { color: #0f766e; }

  /* ── CTA ── */
  .bc-cta { background: linear-gradient(135deg, #0d1b3e 0%, #134e4a 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .bc-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(20,184,166,0.07); filter: blur(60px); pointer-events: none; }
  .bc-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .bc-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .bc-cta-tag { display: inline-block; background: rgba(20,184,166,0.18); border: 1px solid rgba(20,184,166,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #5eead4; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .bc-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .bc-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .bc-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .bc-cta-btn-primary { padding: 16px 32px; background: #0d9488; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .bc-cta-btn-primary:hover { background: #0f766e; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(13,148,136,0.4); }
  .bc-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .bc-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .bc-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .bc-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .bc-cta-check { width: 18px; height: 18px; background: rgba(20,184,166,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #5eead4; flex-shrink: 0; }
`;

const contractItems = [
  { icon: "🤝", name: "Vendor Agreement", detail: "TechSupplies Co. · Due Dec 18", badge: "Signed", badgeClass: "bc-status-done" },
  { icon: "📋", name: "Service Agreement", detail: "Web Design Studio · Rev 2", badge: "In Review", badgeClass: "bc-status-review" },
  { icon: "🔒", name: "NDA — Executive Team", detail: "4 signatories · Confidential", badge: "Draft", badgeClass: "bc-status-draft" },
  { icon: "👔", name: "Employment Contract", detail: "New Hire · Start Jan 6", badge: "Signed", badgeClass: "bc-status-done" },
];

const contractTypes = [
  { icon: "🤝", title: "Vendor & Supplier Agreements", desc: "Protect your supply chain with clear terms on pricing, delivery, quality standards, and liability.", covers: "Covers: Payment terms · SLAs · Warranties · Indemnification" },
  { icon: "🔒", title: "Non-Disclosure Agreements", desc: "Safeguard confidential information when working with employees, contractors, or potential partners.", covers: "Covers: Mutual & one-way · Duration · Remedies" },
  { icon: "💼", title: "Service Agreements", desc: "Define the scope, timeline, deliverables, and payment terms for any service your business provides or receives.", covers: "Covers: Scope · IP rights · Termination · Disputes" },
  { icon: "🤲", title: "Partnership Agreements", desc: "Establish clear ownership, responsibilities, profit sharing, and exit provisions between business partners.", covers: "Covers: Equity · Decision-making · Buyout provisions" },
  { icon: "👔", title: "Employment Contracts", desc: "Onboard employees and contractors with legally sound agreements that protect both parties from the start.", covers: "Covers: Role · Compensation · Non-compete · IP ownership" },
  { icon: "📜", title: "IP Assignment Agreements", desc: "Ensure all intellectual property created for your business is properly assigned to your company — not the contractor.", covers: "Covers: Work-for-hire · Assignment · Moral rights" },
];

const risks = [
  { icon: "💸", title: "Costly Disputes Without Clear Terms", desc: "Vague or missing contract terms are the #1 cause of business disputes — and defending them costs far more than prevention." },
  { icon: "🏃", title: "No Recourse When Things Go Wrong", desc: "Without an enforceable contract, you have little legal standing to recover losses when a vendor, client, or partner breaches." },
  { icon: "💡", title: "Losing Your Own IP", desc: "Without proper IP assignment clauses, work created by contractors or employees may legally belong to them — not you." },
];

const included = [
  { icon: "✍️", title: "Fully Custom Drafting", desc: "Every contract is drafted from scratch for your specific situation — no generic templates that leave gaps." },
  { icon: "🔍", title: "Thorough Legal Review", desc: "We review contracts sent to you by vendors, clients, and partners to flag unfair terms before you sign." },
  { icon: "🔄", title: "Negotiation Support", desc: "We negotiate directly on your behalf or advise you through counterproposals to improve your position." },
  { icon: "📁", title: "Template Library", desc: "Get a library of pre-approved contract templates your team can use for routine agreements going forward." },
];

const processSteps = [
  { num: "01", title: "Share Your Needs", desc: "Tell us about the contract — who's involved, what's at stake, and what outcome you need." },
  { num: "02", title: "Draft or Review", desc: "We draft your contract from scratch or thoroughly review an existing one, flagging every risk." },
  { num: "03", title: "Negotiate & Revise", desc: "We support counterproposals and revisions until the terms fully protect your interests." },
  { num: "04", title: "Execute with Confidence", desc: "Sign with certainty knowing every clause works in your favor and stands up legally." },
];

const LegalBusinessContracts = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="bc-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="bc-hero">
        <div className="bc-hero-blob1" />
        <div className="bc-hero-blob2" />
        <div className="bc-hero-inner">
          <div>
            <button className="bc-back-btn" onClick={() => navigateTo("")}>
              ← Back to Legal Services
            </button>
            <div className="bc-badge">
              <span className="bc-badge-dot" />
              Contract Drafting & Review
            </div>
            <h1>
              Contracts That{" "}
              <span className="bc-gradient-text">Actually Protect You</span>
            </h1>
            <p className="bc-hero-sub">
              Every business relationship lives or dies by its contracts. We draft,
              review, and negotiate airtight agreements so your interests are
              protected before you sign — not after something goes wrong.
            </p>
            <div className="bc-btn-group">
              <button className="bc-btn-primary">Get a Contract Drafted →</button>
              <button className="bc-btn-secondary">Review My Contract</button>
            </div>
            <div className="bc-trust-items">
              {["Custom drafting from scratch", "48-hr turnaround", "All contract types", "Negotiation support included"].map((t, i) => (
                <div key={i} className="bc-trust-item">
                  <span className="bc-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="bc-hero-card">
            <div className="bc-card-header">
              <div>
                <div className="bc-card-title-label">Your Documents</div>
                <div className="bc-card-title-value">Contract Manager</div>
              </div>
              <span className="bc-card-badge">● 4 Active</span>
            </div>
            {contractItems.map((item, i) => (
              <div key={i} className="bc-contract-item">
                <span className="bc-contract-icon">{item.icon}</span>
                <div style={{ flex: 1 }}>
                  <div className="bc-contract-name">{item.name}</div>
                  <div className="bc-contract-detail">{item.detail}</div>
                </div>
                <span className={`bc-contract-badge ${item.badgeClass}`}>{item.badge}</span>
              </div>
            ))}
            <div className="bc-card-metric">
              <div>
                <div className="bc-metric-label">Contracts Managed This Year</div>
                <div className="bc-metric-value">38</div>
              </div>
              <div className="bc-metric-badge">↑ 22% YoY</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="bc-stats">
        <div className="bc-stats-grid">
          {[
            { num: "8,500+", label: "Contracts Drafted & Reviewed" },
            { num: "48 hrs", label: "Average Turnaround" },
            { num: "99%", label: "Client Satisfaction" },
            { num: "$0", label: "Hidden Fees" },
          ].map((s, i) => (
            <div key={i} className="bc-stat-item">
              <div className="bc-stat-num">{s.num}</div>
              <div className="bc-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Contract Types ── */}
      <section className="bc-section bc-types-bg">
        <div className="bc-container">
          <div className="bc-section-header">
            <div className="bc-kicker">Contract Types</div>
            <h2>Every Agreement Your Business Needs</h2>
            <p>
              From simple NDAs to complex multi-party agreements, we handle every
              contract type with precision and speed.
            </p>
          </div>
          <div className="bc-types-grid">
            {contractTypes.map((type, i) => (
              <div key={i} className="bc-type-card">
                <div className="bc-type-icon">{type.icon}</div>
                <div className="bc-type-title">{type.title}</div>
                <div className="bc-type-desc">{type.desc}</div>
                <div className="bc-type-covers">{type.covers}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why It Matters + What's Included ── */}
      <section className="bc-section">
        <div className="bc-container">
          <div className="bc-why-grid">
            <div className="bc-why-left">
              <div className="bc-kicker">The Risk of Bad Contracts</div>
              <h2>A Weak Contract Can Cost More Than Your Business</h2>
              <p>
                Most small businesses rely on handshake deals, downloaded templates,
                or contracts written by the other side's lawyer. Here's what that
                actually costs you.
              </p>
              <div className="bc-risk-items">
                {risks.map((r, i) => (
                  <div key={i} className="bc-risk-item">
                    <div className="bc-risk-icon">{r.icon}</div>
                    <div>
                      <div className="bc-risk-title">{r.title}</div>
                      <div className="bc-risk-desc">{r.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="bc-kicker">What's Included</div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#0d1b3e', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '32px' }}>
                Everything in Our Contract Service
              </h2>
              <div className="bc-included-list">
                {included.map((item, i) => (
                  <div key={i} className="bc-included-item">
                    <div className="bc-included-icon">{item.icon}</div>
                    <div>
                      <div className="bc-included-title">{item.title}</div>
                      <div className="bc-included-desc">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="bc-section bc-process-bg">
        <div className="bc-container">
          <div className="bc-section-header">
            <div className="bc-kicker">How It Works</div>
            <h2>From Request to Signed in 4 Steps</h2>
            <p>Fast, thorough, and tailored to your specific situation every time.</p>
          </div>
          <div className="bc-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="bc-process-step">
                <div className="bc-process-num">{step.num}</div>
                <div className="bc-process-title">{step.title}</div>
                <div className="bc-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="bc-cta">
        <div className="bc-cta-blob1" />
        <div className="bc-cta-blob2" />
        <div className="bc-cta-inner">
          <div className="bc-cta-tag">Start Today</div>
          <h2>Stop Signing Contracts You Don't Fully Understand</h2>
          <p>
            Get a contract drafted or reviewed today. Our attorneys turn requests
            around in 48 hours — so you never have to delay a deal waiting on
            legal.
          </p>
          <div className="bc-cta-btn-group">
            <button className="bc-cta-btn-primary">Get a Contract Drafted</button>
            <button className="bc-cta-btn-secondary">Submit for Review</button>
          </div>
          <div className="bc-cta-reassurances">
            {["Custom drafting", "48-hr turnaround", "Flat-rate pricing", "No hidden fees"].map((r, i) => (
              <div key={i} className="bc-cta-reassurance">
                <span className="bc-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalBusinessContracts;
